import React from "react";
import ReactWOW from "react-wow";

// https://www.iconfont.cn/collections/detail?spm=a313x.7781069.1998910419.d9df05512&cid=16990

class About extends React.Component {
  render() {
    return (
      <section id="about" className="white">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <h2>INTRODUCTION</h2>
              </div>
              <p>
                I’m the Best Coder! Challenge Campus Edition 2020 aims to
                discover the most accurate and most efficient coder.
              </p>
              <p>Through this competition, we aim to: </p>
              <ul>
                <li>
                  Equip undergraduates with essential data analytics skills and
                  expertise to prepare them for the new digital economy
                </li>
                <li>
                  Bring the tech community closer through problem solving and
                  knowledge sharing together
                </li>
                <li>
                  Provide participants with the opportunity to work on real
                  dataset and challenges in the internet industry{" "}
                </li>
              </ul>
            </div>
          </div>
          <div className="flex-box fontSize">
            <ReactWOW animation="fadeInUp" delay="0.1s">
              <div className="box box-2">
                <h5>Why should YOU join?</h5>
                <img src="images/about-01.png" alt="" />
                <p>
                  I’m the Best Coder! Challenge Campus Edition 2020 is specially
                  organised for tech enthusiasts like you to develop and grow
                  your coding abilities.{" "}
                </p>
              </div>
            </ReactWOW>
            <ReactWOW animation="fadeInUp" delay="0.1s">
              <div className="box box-2">
                <h5>Who can join?</h5>
                <img src="images/about-02.png" alt="" />
                <p>
                  We welcome all undergraduate students from all Singapore
                  universities.{" "}
                </p>
                <p>
                  In the interest of fairness, employees of Sea Limited are not
                  eligible to participate in the competition.
                </p>
              </div>
            </ReactWOW>
            <ReactWOW animation="fadeInUp" delay="0.1s">
              <div className="box box-2">
                <h5>How to join?</h5>
                <img src="images/about-03.png" alt="" />
                <p>
                  Join the fun for free! Register by forming a team of 2 - 4
                  members. Individual sign-ups are not allowed.{" "}
                </p>
              </div>
            </ReactWOW>
            <ReactWOW animation="fadeInUp" delay="0.1s">
              <div className="box box-2">
                <h5>What else?</h5>
                <img src="images/about-04.png" alt="" />
                <p>
                  Shortlisted individuals will have the opportunity to attend
                  free training workshops specially organised by Shopee. To sign
                  up, indicate your interest for the training workshop during
                  registration. Confirmation will be sent to shortlisted
                  individuals only!
                </p>
              </div>
            </ReactWOW>
          </div>

          {/* <div className="section-title">
            <h2 className="title-2">About the competition</h2>
          </div>
          <p>
            I’m the Best Coder! Challenge Campus Edition 2020 is a one-day data
            analytics competition, open to all undergraduate students.{" "}
          </p>
          <p>
            The competition consists of 2 rounds of data analysis problems
            designed by Shopee tech teams. Participants must analyse the
            dataset, draw insightful conclusions and solve the problems in a
            specified amount of time.{" "}
          </p>
          <p>
            Not only will participants get a chance to code to generate insights
            that solve real industry problems, this competition will also
            provide them with an opportunity to test their coding skills and
            understand the importance of data analytics skills required in
            Shopee.
          </p> */}
        </div>
      </section>
    );
  }
}

export default About;
